<template>
	<v-chart :ref="id" :options="options" :autoresize="true"></v-chart>
</template>
<style>
.echarts {
  width: 100%;
  height: 100%;
}
</style>
<script>
import ECharts from 'vue-echarts/components/ECharts'
import 'echarts/lib/chart/bar'
import 'echarts/lib/chart/radar'
import 'echarts/lib/chart/pie'
import 'echarts/lib/chart/line'
import 'echarts/lib/chart/heatmap'
import 'echarts/lib/chart/scatter'

import 'echarts/lib/component/legend'
import 'echarts/lib/component/tooltip'
import 'echarts/lib/component/toolbox'
import 'echarts/lib/component/legendScroll'
import 'echarts/lib/component/visualMap'
import 'echarts/lib/component/title'

export default {
  name: 'Chart',
  components: {
    'v-chart': ECharts
  },
  props: ['options', 'id'],
  data () {
    return {
      
    }
  },
  created: function() {
  }
}
</script>